/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Claim from './Claim/index'
import ClaimAmount from './ClaimAmount/index'
import Info from './Info/index'
import Invoice from './Invoice/index'
import InvoiceAmount from './InvoiceAmount/index'
import React from 'react'
import Tabs from './Tabs/index'
import TotalAmount from './TotalAmount/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TotalAmount
  viewPath={`${viewPath}/TotalAmount`}
/>
<ClaimAmount
  viewPath={`${viewPath}/ClaimAmount`}
/>
<InvoiceAmount
  viewPath={`${viewPath}/InvoiceAmount`}
/>
</div>
<Info
  viewPath={`${viewPath}/Info`}
/>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<Claim
  viewPath={`${viewPath}/Claim`}
/>
<Invoice
  viewPath={`${viewPath}/Invoice`}
/>
</div>
{children}
</React.Fragment>)
}